import { FC, useEffect, useRef } from 'react';
import { getTreaserAni } from '../../util';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import { TopTip } from '@/components/UI/svg/Wave2';

const TreaserA: FC<{ curStage: 1 | 2 | 3 | 0 }> = ({ curStage }) => {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('glacierwave.treaser');
    const { locale } = useRouter();
    const tipBox = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const treaserAni = getTreaserAni();
        treaserAni?.create({
            syncFromTo: [['.banner-container #treaser-ani-title-container', { opacity: 1 }, { opacity: 0.1 }]],
            triggerElement: '.banner-container',
            triggerHook: 0,
            offset: -100,
            duration: 300,
        });
    }, []);

    return (
        <div className={css.glacierWaveTreaserA}>
            <div className="banner-img-sticky">
                <div className="banner-img-box">
                    <NextImage
                        webpSrc={require('@publicLocal/glacier-and-wave-2/pc/treaser-banner.webp')}
                        src={require('@publicLocal/glacier-and-wave-2/pc/treaser-banner.jpg')}
                    />
                </div>
            </div>
            {curStage === 1 && (
                <div className="top-tip">
                    <TopTip />
                    <p className="text">{t('top_tip')}</p>
                </div>
            )}
            <div className="banner-container">
                <div className="ces-img-box">
                    <NextImage webpSrc={require('@publicLocal/ces_2023.webp')} src={require('@publicLocal/ces_2023.png')} />
                </div>
                <div id="treaser-ani-title-container">
                    {/* {curStage === 1 && <div className="start-time">{t('living_start_time')}</div>} */}
                    {curStage === 1 && (
                        <>
                            <div className="treaser-title">{t('smart_living_title')}</div>
                            <div className="treaser-subtitle">{t('living_description')}</div>
                        </>
                    )}
                    {curStage !== 1 && locale === 'au' && (
                        <>
                            <div className="treaser-title launch">{t('smart_living_title_launch')}</div>
                            <div className="treaser-subtitle">{t('living_description_launch')}</div>
                        </>
                    )}
                </div>
                <div className="text-wrapper">
                    <div className="product-intro-container">
                        <div className="product-box">
                            <div className="product-name">{t('product_glacier')}</div>
                            <div className="product-line"></div>
                            <div className="product-desc">
                                {t.rich('desc_ice_maker', {
                                    line: (text: any) => <span className="line1">{text}</span>,
                                })}
                            </div>
                        </div>
                        <div className="product-box">
                            <div className="product-name">{t('product_wave_two')}</div>
                            <div className="product-line"></div>
                            <div className="product-desc">
                                {t.rich('desc_most_powerful', {
                                    line: (text: any) => <span className="line1">{text}</span>,
                                })}
                            </div>
                        </div>
                    </div>
                    <div className="tip-box" ref={tipBox}>
                        <div className="tip-content">
                            {locale === 'jp' && <span className="tip-icon">「</span>}
                            {t('desc_ces_promising')}
                            {locale === 'jp' && <span className="tip-icon">」</span>}
                        </div>
                        <div className="tip-author">
                            {t.rich('author_engadget', {
                                name: (text: string) => <span className="author-name">{text}</span>,
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TreaserA;
